import { useId, ChangeEvent, FC, ReactNode } from 'react';
import { Checkbox as MCheckbox } from '@mantine/core';
import classNames from 'classnames';

import styles from './styles.module.scss';
import ErrorText from '../ErrorText';
import React from 'react';

const CheckboxIcon: FC<{
  indeterminate: boolean;
  className: string;
}> = ({ indeterminate, className }) => {
  return indeterminate ? (
    <> </>
  ) : (
    <svg viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={className}>
      <path
        d="M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

interface Props {
  onChecked?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  label: ReactNode;
  required?: boolean;
  checked?: boolean;
  error?: ReactNode;
  ariaLabel?: string;
  labelPosition?: 'left' | 'right';
}

const Checkbox: FC<Props> = ({
  label,
  className,
  onChecked,
  required,
  checked,
  error,
  ariaLabel,
  labelPosition = 'right',
}): JSX.Element => {
  const id = useId();
  const errorId = 'error-' + id;

  return (
    <>
      <MCheckbox
        checked={checked}
        onChange={onChecked}
        icon={CheckboxIcon}
        label={label}
        className={classNames(styles.checkbox, className)}
        radius={'xs'}
        required={required}
        aria-describedby={error ? errorId : undefined}
        aria-invalid={!!error}
        aria-label={ariaLabel}
        labelPosition={labelPosition}
      />
      <ErrorText id={errorId} error={error} />
    </>
  );
};

export default Checkbox;
